import { institutions } from "@/mocks/partes";

export default function InstitutionsTable() {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-foreground-900">Órgãos e Instituições ({institutions.length})</h3>
        <button className="px-3 py-1.5 text-xs font-medium text-primary-700 bg-primary-50 rounded-lg hover:bg-primary-100 transition-colors whitespace-nowrap">
          <i className="ri-add-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1" />
          Novo órgão
        </button>
      </div>
      <div className="overflow-x-auto bg-white rounded-xl border border-background-200/70">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-background-200 bg-background-50/50">
              <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Nome</th>
              <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Tipo</th>
              <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider hidden md:table-cell">Município/UF</th>
              <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider hidden lg:table-cell">Contato</th>
              <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider hidden xl:table-cell">E-mail</th>
              <th className="text-center px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Projetos</th>
              <th className="text-center px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Docs</th>
              <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Status</th>
            </tr>
          </thead>
          <tbody>
            {institutions.map((inst) => (
              <tr key={inst.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="px-4 py-3 text-sm font-medium text-foreground-900">{inst.name}</td>
                <td className="px-4 py-3 text-xs text-foreground-500">{inst.type}</td>
                <td className="px-4 py-3 text-xs text-foreground-500 hidden md:table-cell">{inst.municipality}/{inst.uf}</td>
                <td className="px-4 py-3 hidden lg:table-cell">
                  <p className="text-sm font-medium text-foreground-900">{inst.contactPerson}</p>
                  <p className="text-xs text-foreground-400">{inst.phone}</p>
                </td>
                <td className="px-4 py-3 text-xs text-foreground-500 hidden xl:table-cell">{inst.email}</td>
                <td className="px-4 py-3 text-center">
                  <span className="text-xs font-semibold text-primary-600">{inst.linkedProjects}</span>
                </td>
                <td className="px-4 py-3 text-center">
                  <span className="text-xs font-semibold text-accent-600">{inst.issuedDocuments}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap bg-primary-100 text-primary-700">{inst.status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}